import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TagInputModule } from 'ngx-chips';

@Component({
  selector: 'app-tag-field',
  templateUrl: './tag-field.component.html',
  imports: [TagInputModule, FormsModule],
})
export class TagFieldComponent implements OnChanges {
  @Input() editable = true;
  @Input() items: TagFieldCustom[] = [];
  @Input() placeholder: string;
  @Input() editableTag = false;

  @Input() hideForm = false;

  @Output() itemsChanged = new EventEmitter<TagFieldCustom[]>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items || changes.editable) {
      this.updateItemsStatus();
    }
  }

  updateItemsStatus(): void {
    if (this.items && this.items.length > 0) {
      for (const item of this.items) {
        item.readonly = !this.editable;
      }
    }
  }

  emitValue(_event?: TagFieldCustom[]): void {
    this.itemsChanged.emit(this.items);
  }

  onTagEdited(value) {
    const { index, tag } = value;
    const updatedItems = [...this.items];
    updatedItems[index].value = tag.value;
    updatedItems[index].display = tag.display;
    this.itemsChanged.emit(updatedItems);
  }
}

export interface TagFieldCustom {
  id?: number;
  codeId?: string;
  display: string;
  value: any;
  image?: string;
  readonly?: boolean;
  isAllowToSendEmail?: boolean;
  hasSubOrganization?: boolean;
  type?: TagFieldType;
  content?: string;
  disableTagEdit?: boolean;
  isStandardTag?: boolean;
  isTenantTag?: boolean;
  isEnabled?: boolean;
}

export enum TagFieldType {
  Normal,
  PreSelection,
  Header,
}

export function transformToTagModal<T>(
  items: T[],
  type: TagFieldType = TagFieldType.Normal
): TagFieldCustom[] {
  if (items && Array.isArray(items)) {
    return items.map(item => {
      return {
        ...item,
        display: item['name'] || item['value'],
        value: item['id'] || item['codeId'],
        image: item['image'],
        type,
      };
    });
  } else {
    return [];
  }
}

export function transformToTagModaByKey<T>(
  items: T[],
  readonlyKey: boolean,
  displayKey: string | null = null,
  valueKey: string | null = null
): TagFieldCustom[] {
  if (items && Array.isArray(items)) {
    return items.map(item => {
      return {
        display: item && displayKey ? item[displayKey] : item,
        value: item && displayKey ? item[valueKey] : item,
        readonly: readonlyKey,
        ...(item?.['id'] && { id: item['id'] }),
        ...(item?.['ownerId'] && { ownerId: item['ownerId'] }),
      };
    });
  } else {
    return [];
  }
}
